export enum RemoveAccountCases {
  Viewer = 'viewer',
  Owner = 'owner',
  OwnerMultiple = 'ownerMultiple',
}
